module.exports = __webpack_public_path__ + "static/media/spin_hublot.075a7ded.png";